import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  routr: any;
  activatedRoute: any;
  _seoService: any;

  constructor(
    private title: Title,
    private meta: Meta,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  // title = "foundation";
  onActivate(event: any) {
    window.scroll(0, 0);
    document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }
}
